import './ReturnButton.css'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  redirectUrl: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const ReturnButton = ({ redirectUrl, icon, children, ...otherProps }: IProps) => {
  const navigate = useNavigate()

  return (
    <Button title='Previous Page' className='btn-lg btnWidth btn btn-default' onClick={() => navigate(redirectUrl)} {...otherProps}>
      <FontAwesomeIcon icon={icon ? icon : ['fas', 'arrow-circle-left']} />&nbsp;
      {children ? children : <span>Return</span>}
    </Button>
  )
}

export default ReturnButton